import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";

function WaterBore() {
  const [activeTab, setActiveTab] = useState("bore");

  return (
    <>
      <Navbar />
      <Sidebar />

      <div className="main-content">

        <h1>Water & Bore Management</h1>

        <div>
          <button onClick={() => setActiveTab("bore")}>
            Bore Master
          </button>

          <button onClick={() => setActiveTab("operations")}>
            Bore Operations
          </button>

          <button onClick={() => setActiveTab("charges")}>
            Water Charges
          </button>

          <button onClick={() => setActiveTab("due")}>
            Due Report
          </button>
        </div>

        {activeTab === "bore" && (
          <div className="section-card">

            <h2>Bore Master</h2>

            <input
              type="text"
              placeholder="Bore Number"
            />

            <input
              type="text"
              placeholder="Sequence"
            />

            <input
              type="text"
              placeholder="Zone"
            />

            <select>
              <option>Active</option>
              <option>Inactive</option>
            </select>

            <button>Add Bore</button>

            <table className="plot-table">
              <thead>
                <tr>
                  <th>Bore No</th>
                  <th>Sequence</th>
                  <th>Zone</th>
                  <th>Status</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>B001</td>
                  <td>1</td>
                  <td>Zone 1</td>
                  <td>Active</td>
                </tr>
              </tbody>
            </table>

          </div>
        )}

        {activeTab === "operations" && (
          <div className="section-card">

            <h2>Bore Operation Logging</h2>

            <input
              type="text"
              placeholder="Bore Number"
            />

            <input
              type="number"
              placeholder="Opening Meter Reading"
            />

            <input
              type="number"
              placeholder="Closing Meter Reading"
            />

            <button>Save Session</button>

            <table className="plot-table">
              <thead>
                <tr>
                  <th>Bore</th>
                  <th>Opening</th>
                  <th>Closing</th>
                  <th>Units Consumed</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>B001</td>
                  <td>100</td>
                  <td>150</td>
                  <td>50</td>
                </tr>
              </tbody>
            </table>

          </div>
        )}

        {activeTab === "charges" && (
          <div className="section-card">

            <h2>Water Charge Entry</h2>

            <input
              type="text"
              placeholder="Plot Number"
            />

            <input
              type="date"
            />

            <input
              type="number"
              placeholder="Amount"
            />

            <input
              type="date"
            />

            <button>Save Charge</button>

            <table className="plot-table">
              <thead>
                <tr>
                  <th>Plot</th>
                  <th>Amount</th>
                  <th>Payment Date</th>
                  <th>Meter Date</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>S253</td>
                  <td>₹500</td>
                  <td>01-06-2026</td>
                  <td>31-05-2026</td>
                </tr>
              </tbody>
            </table>

          </div>
        )}

        {activeTab === "due" && (
          <div className="section-card">

            <h2>Water Collection Due Report</h2>

            <select>
              <option>All Zones</option>
              <option>Zone 1</option>
              <option>Zone 2</option>
            </select>

            <select>
              <option>All Supervisors</option>
              <option>Naresh</option>
              <option>Kiran</option>
            </select>

            <table className="plot-table">
              <thead>
                <tr>
                  <th>Plot</th>
                  <th>Owner</th>
                  <th>Zone</th>
                  <th>Supervisor</th>
                  <th>Outstanding</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>F412</td>
                  <td>Priya Agarwal</td>
                  <td>Zone 5</td>
                  <td>Kiran</td>
                  <td>₹1200</td>
                </tr>
              </tbody>
            </table>

          </div>
        )}

      </div>
    </>
  );
}

export default WaterBore;